<p>hl-display-additional-costs-step works!</p>
